module.exports = __webpack_public_path__ + "img/member-communications.22a180a3.png";